import { useRef } from 'react';
import { api_getProductByUrl } from '~/backend/api_calls';

const PRODUCT_CACHE_TTL_MS = 60_000;
const PRODUCT_CACHE_MAX_ENTRIES = 50;
const productCache = new Map();

const isFresh = entry => entry && Date.now() - entry.ts < PRODUCT_CACHE_TTL_MS;

export const getProductByUrlCached = slug => {
	if (!slug) return Promise.reject(new Error('No product slug'));

	const cached = productCache.get(slug);
	if (isFresh(cached)) return cached.promise;

	if (productCache.size >= PRODUCT_CACHE_MAX_ENTRIES) {
		const oldestKey = productCache.keys().next().value;
		if (oldestKey) productCache.delete(oldestKey);
	}

	const promise = api_getProductByUrl(slug);
	productCache.set(slug, { promise, ts: Date.now() });
	promise.catch(() => productCache.delete(slug));
	return promise;
};

const toProductSlug = eurl => (eurl ? eurl.split('/').filter(Boolean).pop() : '');

const useProductPrefetch = (eurl, hoverDurationMs = 1000) => {
	const timerRef = useRef(null);

	const handlePrefetch = () => {
		const slug = toProductSlug(eurl);
		if (!slug || isFresh(productCache.get(slug)) || timerRef.current) return;
		timerRef.current = setTimeout(() => {
			getProductByUrlCached(slug).catch(() => {});
			timerRef.current = null;
		}, hoverDurationMs);
	};

	const cancelPrefetch = () => {
		if (timerRef.current) {
			clearTimeout(timerRef.current);
			timerRef.current = null;
		}
	};

	return { handlePrefetch, cancelPrefetch };
};

export default useProductPrefetch;
